// extracted by mini-css-extract-plugin
module.exports = {"light":"_2sX0LMGM5EOM8Zw7lE42-G"};